import { BarChart } from '@mui/x-charts'
import { InvoiceState, TotalInvoiceAmounts } from '../GeneratedClients/FreeBillApi'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

const InvoicesChart = ({data}: {data: TotalInvoiceAmounts[]}) => {

  const navigate = useNavigate()

  const currencyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format

  var dataSet = data.map(x => ({
    title: `${x.month}/${x.year}`, 
    count: data.length, 
    totalNetAmount: x.totalNetAmount, 
    paid: x.totalAmountCategories?.find(y => y.name === InvoiceState.Paid)?.totalNetAmount??null,
    pending: x.totalAmountCategories?.find(y => y.name === InvoiceState.Pending)?.totalNetAmount??null,
    pastDue: x.totalAmountCategories?.find(y => y.name === InvoiceState.PastDue)?.totalNetAmount??null,
  }))

  const handleAxisClick = (e: any, data: any | null) => {
    var axisValues: string[] | undefined = data.axisValue.split("/")
    if(axisValues && axisValues.length >=2)
    {
      var month = Number(axisValues[0])
      var year = Number(axisValues[1])
      var invoiceDate_Gt = moment().month(month-1).year(year).startOf("month").toISOString()
      var invoiceDate_Lt = moment().month(month-1).year(year).endOf("month").toISOString()
      navigate({
        pathname: "/invoices",
        search:`filter=${JSON.stringify(
          { 
            invoiceDate_Gt: invoiceDate_Gt,
            invoiceDate_Lt: invoiceDate_Lt,
          }
        )}`
      })
    }
  }

  return (
    <BarChart 
      loading={data.length === 0}
      slotProps={{
        legend: {hidden: false}
      }}
      margin={{ left: 100 }}
      grid={{horizontal: true}}
      onAxisClick={handleAxisClick}
      series={[
        //@ts-ignore
        //{dataKey: "totalNetAmount", label: "Summe netto", stack: "stack1", color: "#00537e", valueFormatter: (v) => (!v ? null : currencyFormatter(v)) },
        //@ts-ignore
        {dataKey: "paid", label: "Bezahlt", stack: "stack2", color: "#a4c74b", valueFormatter: (v) => (!v ? null : currencyFormatter(v))},
        //@ts-ignore
        {dataKey: "pending", label: "Offen", stack: "stack2", color: "#ed6c02", valueFormatter: (v) => (!v ? null : currencyFormatter(v))},
        //@ts-ignore
        {dataKey: "pastDue", label: "Fällig", stack: "stack2", color: "#bb0000", valueFormatter: (v) => (!v ? null : currencyFormatter(v))},
      ]}
      xAxis={[
        {
          dataKey: "title",
          valueFormatter(value, context) {
            var totalNetAmount = dataSet.find(d => d.title === value)?.totalNetAmount ?? 0
            return context.location === "tick" ? value : `${value} ${totalNetAmount > 0 ? ` | Summe netto: ${currencyFormatter(totalNetAmount)}` : ""}`
          },
          scaleType: "band",
          tickLabelStyle: data.length > 20 ? {
            angle: 45,
            dominantBaseline: "hanging",
            textAnchor: "start"
          } : undefined
        }
      ]}
      //@ts-ignore
      dataset={dataSet}
      height={300}
    />
  )
}

export default InvoicesChart